export enum DomId {
  ApplicationHeader = 'applicationHeader',
  TablePagination = 'tablePagination',
  SearchHeaderArea = 'searchHeaderArea',
}
